import React from "react";

import { Route, IndexRoute } from "react-router";

import AdminDashboard from "../pages/dashboard/adminDashboard";

import Category from "../pages/category/category";
import CategoryForm from "../pages/category/form/categoryForm";

import Country from "../pages/country/country";
import CountryForm from "../pages/country/form/countryForm";

import State from "../pages/state/state";
import StateForm from "../pages/state/form/stateForm";

import City from "../pages/city/city";
import CityForm from "../pages/city/form/cityForm";

import Users from '../pages/users/users';
import UsersForm from '../pages/users/form/usersForm';

import Rules from '../pages/rules/rules';
import RulesForm from '../pages/rules/form/rulesForm';

export const adminRouters = (
	<Route path="admin">
		<IndexRoute component={props => <AdminDashboard {...props} />} />
		<Route path="categorias" component={(props) => <Category {...props} />} />
		<Route path="categorias/novo" component={(props) => <CategoryForm {...props} />} />
		<Route path="categorias/:id/editar" component={(props) => <CategoryForm {...props} />} />

		<Route path="paises" component={(props) => <Country {...props} />} />
		<Route path="paises/novo" component={(props) => <CountryForm {...props} />} />
		<Route path="paises/:id/editar" component={(props) => <CountryForm {...props} />} />

		<Route path="estados" component={(props) => <State {...props} />} />
		<Route path="estados/novo" component={(props) => <StateForm {...props} />} />
		<Route path="estados/:id/editar" component={(props) => <StateForm {...props} />} />

		<Route path="cidades" component={(props) => <City {...props} />} />
		<Route path="cidades/novo" component={(props) => <CityForm {...props} />} />
		<Route path="cidades/:id/editar" component={(props) => <CityForm {...props} />} />

		<Route path="usuarios" component={(props) => <Users {...props} />} />
		<Route path="usuarios/novo" component={(props) => <UsersForm {...props} />} />
		<Route path="usuarios/:id/editar" component={(props) => <UsersForm {...props} />} />

		<Route path="papeis" component={(props) => <Rules {...props} />} />
		<Route path="papeis/novo" component={(props) => <RulesForm {...props} />} />
		<Route path="papeis/:id/editar" component={(props) => <RulesForm {...props} />} />

	</Route>
);
